import { Label, Remark } from "@/services/backend/processes/state/state";
import { cn } from "@/shared/lib/utils";

export const processStateLabel: { [key: string]: string } = {
  [Label.Running]: "Aktiv",
  [Label.Archived]: "Archiviert",
  [Label.Done]: "Abgeschlossen",
};

export function ProcessStateLabel({
  status,
  remark = "",
  className = "",
}: {
  status: string;
  remark?: string;
  className?: string;
}) {
  if (remark === Remark.Canceled) {
    return <span className={cn(className)}>Storniert</span>;
  }
  return <span className={cn(className)}>{processStateLabel[status]}</span>;
}
